module.exports = __webpack_public_path__ + "static/media/rightImg.37dd0e27.jpg";